'use strict';
(function () {
  angular.module('pentaApp').factory('receipt.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/receipt', {}, {
      findReference: {
        method: 'GET',
        isArray: false
      },
      addReceipt: {
        method: 'POST',
        isArray: false
      }
    });
  }

})();